import service from '@/service'
import urlManager from '@/urlManager'

/**
 * This contains utilities related to usage of feature flags
 */
export default {
  methods: {
    getFeatureFlagValue(orgId, flagName) {
      const org = this.$store.getters.orgById(orgId)
      return org?.featureSummary[flagName]
    },
    async satisfyFeature(orgId, featureName) {
      const { data } = await service.client.get(urlManager.satisfyFeature(orgId, featureName))
      return data.satisfies
    }
  }
}
